<template>
    <v-card>
        <div>
            <v-img
                :src="empresa.url_imagem_posto ? empresa.url_imagem_posto : require('@/assets/posto-default.png')"
                aspect-ratio="2.75"
            >
            </v-img>
        </div>
        <v-card-text>
            <v-stepper v-model="step" style="box-shadow:none;">
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-layout pt-4 row wrap justify-space-around fill-height>
                            <v-flex xs12 sm5>
                                <v-text-field
                                    readonly
                                    label="Razão Social"
                                    v-model="empresa.razao_social"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-text-field
                                    readonly
                                    label="Nome Fantasia"
                                    v-model="empresa.nome_fantasia"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-select
                                    readonly
                                    label="Tipo de Empresa"
                                    v-model="empresa.tipo_empresa"
                                    :items="tipo_empresa"
                                    item-value="value"
                                    item-text="text"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-text-field
                                    readonly
                                    label="CNPJ"
                                    v-model="empresa.cnpj"
                                    mask="##.###.###/####-##"
                                    class="text-xs-center"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-text-field
                                    readonly
                                    label="CPF do representante"
                                    v-model="empresa.administrador.cpf"
                                    mask="###.###.###-##"
                                    class="text-xs-center"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    readonly
                                    label="Nome do Representante"
                                    v-model="empresa.administrador.nome"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    readonly
                                    label="Sobrenome do Representante"
                                    v-model="empresa.administrador.sobrenome"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    readonly
                                    label="Telefone do Representante"
                                    v-model="empresa.administrador.telefone"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    readonly
                                    label="Email do Representante"
                                    v-model="empresa.administrador.email"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center pt-2 pb-2">Endereço</v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    readonly
                                    label="Logradouro"
                                    v-model="empresa.endereco.logradouro"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field
                                    readonly
                                    label="Número"
                                    v-model="empresa.endereco.numero"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    readonly
                                    label="Cidade"
                                    v-model="empresa.endereco.cidade"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    readonly
                                    label="Bairro"
                                    v-model="empresa.endereco.bairro"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-text-field
                                    readonly
                                    label="Estado"
                                    v-model="empresa.endereco.estado"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field
                                    readonly
                                    label="País"
                                    v-model="empresa.endereco.pais"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                    readonly
                                    label="CEP"
                                    v-model="empresa.endereco.cep"
                                    mask="#####-###"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn color="primary" @click="step++" round block class="mt-3" v-if="empresa.tipo_empresa == 3">
                                    <v-icon class="mr-1">remove_red_eye</v-icon> Postos Integrados
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-layout pt-4 row wrap justify-space-around fill-height>
                            <v-flex xs12>
                                <h3 class="text-xs-center">Posto Integrados</h3>
                            </v-flex>
                            <v-flex xs12>
                                <v-list>
                                    <v-list-tile
                                        v-for="(posto, index) in postos"
                                        :key="index"
                                    >
                                        <v-list-tile-avatar>
                                            <v-avatar
                                                color="grey"
                                                size="40"
                                            >
                                                    <img v-if="posto.url_imagem_posto" :src="posto.url_imagem_posto" alt="trevor">
                                                    <v-icon dark v-else>local_gas_station</v-icon>
                                            </v-avatar>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title v-text="posto.nome_fantasia"></v-list-tile-title>
                                            <v-list-tile-sub-title v-text="`CNPJ: ${posto.cnpj}`"></v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile v-if="postos.length == 0">
                                        <v-list-tile-content>
                                            <v-list-tile-title style="width: 100%; text-align: center;">
                                                Não existe posto integrados
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                            <v-flex xs12 class="mt-3">
                                <v-btn color="primary" @click="step--" round flat>
                                    <v-icon class="mr-1">arrow_back</v-icon> Voltar
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
        <v-card-actions>
            <v-btn flat block @click="$emit('fechar')">Voltar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
  props: ['empresa'],
  data: () => ({
    tipo_empresa: [
        { text: 'Controle de Frota', value: 1 },
        { text: 'Revendedora de veículos', value: 2 },
        { text: 'Automação', value: 3 },
        { text: 'Venda de Produtos', value: 4 },
        { text: 'Prestação de Serviços', value: 5 },
        { text: 'Venda de Produtos e Serviços', value: 6 },
        { text: 'Instituição Beneficente', value: 7 },
        { text: 'Integradora', value: 8 }
    ],
    step: 1,
    postos: []
  }),
  beforeMount () {
    if (this.empresa) this.pegarPostosIntegrados()
  },
  methods: {
    pegarPostosIntegrados () {
        this.$store.dispatch('pegarTodosPostos', {
            cnpj_empresa: this.empresa.cnpj,
            automacao: true
        }).then(json => {
            this.postos = json
        })
    }
  }
}
</script>
